import { EyeSlash, ShieldCheck } from "@phosphor-icons/react";
import type { AudienceIdentityPolicy } from "../../shared/audienceIdentity.ts";
import type { AudienceIdentityTransition } from "../../shared/types.ts";
import {
  describeAudiencePrivacyForStaff,
  describeIdentityTransition,
} from "../admin/audienceIdentityControls.ts";

export function AudiencePrivacyCue({
  policy,
  transition,
}: {
  policy: AudienceIdentityPolicy;
  transition?: AudienceIdentityTransition | null;
}) {
  const copy = describeAudiencePrivacyForStaff(policy);
  const transitionCopy = transition ? describeIdentityTransition(transition) : null;
  const Icon = policy.publicAuthorDisplay === "hidden" ? EyeSlash : ShieldCheck;
  return (
    <span
      className="audience-privacy-cue"
      data-testid="audience-privacy-cue"
      title={transitionCopy ? `${copy.detail} ${transitionCopy.detail}` : copy.detail}
    >
      <Icon weight="bold" aria-hidden="true" /> {transitionCopy?.label ?? copy.label}
    </span>
  );
}
